import { AccountsUpdateModal } from '@teuteuf-games/accounts-update-modal';
import { useContext } from 'react';

import UserContext from '../providers/UserProvider';

const AccountsUpdateComponent = () => {
  const { showAccountsUpdateModal } = useContext(UserContext);

  return (
    <div className="text-start">
      <AccountsUpdateModal
        show={showAccountsUpdateModal}
        loggedIn={false} /** set to false since on different domain */
      />
    </div>
  );
};

export default AccountsUpdateComponent;
